import { createAction, props } from '@ngrx/store';
import { createRegisterActions } from 'src/app/common-components/register/models/register-actions';
import { CallCostsFilterOption } from '../models/call-cost-filter-option';
import { CallCostRegisterListItem } from '../models/call-cost-register-results.model';

const area = 'CallCost Register';
export const callCostRegisterAdapterActions = createRegisterActions<CallCostRegisterListItem>(area);

export const callCostRegisterInitialFilter = createAction(
   `[${area}] Initial Filter`,
   props<{ filters: CallCostsFilterOption[] }>()
);

export const addProviderCallRateFile = createAction(`[${area}] Add CallCost`);
